export default (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});